import type { Doc } from "~/shared/types";
import { useDataStore } from "~/stores";
import { getPageDisplayName } from "~/utils/common";
import { makeFolderComparator } from "~/utils/comparator";

import type { Actions } from "..";

export default (_actions: Actions) => ({
  /**
   * Group and sort docs by folder with optional current folder prioritization
   */
  groupAndSortDocsByFolder: (docs: Doc[], currentFolderDuid?: string | null) => {
    const dataStore = useDataStore();

    const grouped = new Map<string, Doc[]>();

    docs.forEach((doc) => {
      const folder = dataStore.getFolderByDuid(doc.folderDuid);
      const folderDisplayName = getPageDisplayName(folder, dataStore.getSpaceByDuid, "abrev") || "Folder";

      const group = grouped.get(folderDisplayName);
      if (group) {
        group.push(doc);
      } else {
        grouped.set(folderDisplayName, [doc]);
      }
    });

    const sortedEntries = Array.from(grouped.entries()).sort(([, docsA], [, docsB]) => {
      const folderA = dataStore.getFolderByDuid(docsA[0]?.folderDuid);
      const folderB = dataStore.getFolderByDuid(docsB[0]?.folderDuid);

      // If we have a current folder, prioritize it
      if (currentFolderDuid) {
        const isACurrentFolder = folderA?.duid === currentFolderDuid;
        const isBCurrentFolder = folderB?.duid === currentFolderDuid;

        if (isACurrentFolder && !isBCurrentFolder) {
          return -1;
        }
        if (isBCurrentFolder && !isACurrentFolder) {
          return 1;
        }
      }

      return makeFolderComparator(dataStore.getSpaceByDuid)(folderA, folderB);
    });

    return sortedEntries;
  },
});
